/**
 * AuthLoading Component
 * 
 * Centralized loading component for authentication states.
 * Provides consistent loading UI across the application.
 */

'use client'

import React from 'react'
import { Loader2 } from 'lucide-react'

interface AuthLoadingProps {
  fullScreen?: boolean
  message?: string
  className?: string
}

export function AuthLoading({ 
  fullScreen = true, 
  message = 'Loading...',
  className = ''
}: AuthLoadingProps) {
  const containerClasses = fullScreen
    ? 'min-h-screen flex items-center justify-center'
    : 'flex items-center justify-center py-12'

  return (
    <div className={`${containerClasses} ${className}`}>
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto"></div>
        <p className="mt-4 text-gray-600">{message}</p>
      </div>
    </div>
  )
}

/**
 * Inline loading indicator for smaller components
 */
export function InlineAuthLoading({ 
  message = 'Loading...' 
}: { 
  message?: string 
}) {
  return (
    <div className="flex items-center gap-3">
      <Loader2 className="w-5 h-5 animate-spin text-primary-500" />
      <span className="text-sm text-gray-600">{message}</span>
    </div>
  )
}